import url from 'url';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Component } from 'react';
import flow from 'lodash/flow';

import withAuthHandling from '../../decorators/auth/withAuthHandling';
import getLoginRedirect from '../../utils/auth/getLoginRedirect';
import unauthRedirectHandler from '../../utils/auth/unauthRedirectHandler';
import { clearMetricsAuthState } from '../../actions/metrics';

import metricsAuthStates from '../../constants/auth/metricsAuthStates';
import Metrics from './Metrics';

export class MetricsRoute extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    metricsAuthState: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    metricsUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const { auth, location, history, metricsAuthState, metricsUrl } = props;
    const loginRedirect = getLoginRedirect(auth, location);

    if (loginRedirect) {
      history.replace(url.format(loginRedirect));
      return;
    }
    if (metricsAuthState === metricsAuthStates.unauthorized || !metricsUrl) {
      history.replace('/');
    }
  }

  componentWillUnmount() {
    this.props.actions.clearMetricsAuthState();
  }

  render() {
    return <Metrics metricsUrl={this.props.metricsUrl} />;
  }
}

function mapStateToProps(state) {
  const { auth, metrics } = state;
  const { metricsAuthState, metricsUrl } = metrics;
  return {
    auth,
    metricsAuthState,
    metricsUrl,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      clearMetricsAuthState: () => dispatch(clearMetricsAuthState()),
    },
  };
}

export default flow(
  connect(mapStateToProps, mapDispatchToProps),
  withAuthHandling({ unauthRedirectHandler }),
)(MetricsRoute);
